<template>
  <a-form-model
    :model="editPagelet"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    style="width:100%"
  >
    <a-form-model-item ref="pageletAttrId">
      <span slot="label">
        {{ typeName }} id
        <a-tooltip>
          <template slot="title">
            {{ $t("k_a85e651", { arg_0: typeName }) }}
          </template>
          <a-icon
            style="opacity: 0.8; transform: translateY(1px)"
            type="question-circle"
          />
        </a-tooltip>
      </span>
      <a-input
        v-model="editPagelet.id"
        @blur="handleIdOrNameChange('id')"
      />
    </a-form-model-item>
    <a-form-model-item
      ref="pageletAttrName"
      :label="$t('k_4fde6e2b', { arg_0: typeName })"
      style="margin-top:16px"
    >
      <a-input
        v-model="editPagelet.name"
        @blur="handleIdOrNameChange('name')"
      />
    </a-form-model-item>
    <a-form-model-item
      ref="pageletAttrDesc"
      :label="$t('k_9e497eb', { arg_0: typeName })"
      style="margin-top:16px"
    >
      <a-input
        v-model="editPagelet.description"
        :placeholder="$t('k_c8242e52')"
        type="textarea"
        :rows="4"
        @change="handleDescChange"
      />
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { $t } from '@/i18n';
import { vueComponentMixin } from '@tencent/data-schema/lib/vue-ui/definitions';
import { message } from '@utils/wuji-message';
import { highlightRect } from '@tencent/ui-core/lib/utils/browser';

export default ({
  name: 'PageletAttr',
  mixins: [vueComponentMixin],
  inject: {
    designer: { from: 'uicore:designer' },
    xyPageConfig: { from: 'xyPageConfig' },
  },
  data() {
    return {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      editPagelet: {
        id: this.designer?.pagelet?.id,
        name: this.designer?.pagelet?.name,
      },
    };
  },
  computed: {
    pagelet() {
      return this.designer?.pagelet;
    },
    typeName() {
      return this.pagelet?.xyType === 'modal' ? $t('k_6bc5d09c') : $t('k_2f628aaf');
    },
    pagelets() {
      return this.designer?.pagelets;
    },
  },
  watch: {
    pagelet: {
      handler(newPagelet) {
        this.editPagelet.id = newPagelet.id;
        this.editPagelet.name = newPagelet.name;
      },
      deep: true,
    },
  },
  methods: {
    handleIdOrNameChange(attr) {
      if (this.editPagelet[attr] === this.pagelet[attr]) return;
      const rect = attr === 'name'
        ? this.$refs.pageletAttrName.$el.getBoundingClientRect()
        : this.$refs.pageletAttrId.$el.getBoundingClientRect();
      if (!this.editPagelet[attr]) {
        highlightRect(rect, 500);
        message.error($t('k_d3707e74', { arg_0: this.typeName, arg_1: attr === 'name' ? $t('k_453d502a') : attr }));
        this.editPagelet[attr] = this.pagelet[attr];
      } else if (this.pagelets.some(item => item[attr] === this.editPagelet[attr])) {
        highlightRect(rect, 500);
        message.error($t('k_8c9e2fe1', { arg_0: this.typeName, arg_1: attr === 'name' ? $t('k_453d502a') : attr }));
        this.editPagelet[attr] = this.pagelet[attr];
      } else if (attr === 'id' && !/^[a-zA-Z][\w-]*$/.test(this.editPagelet[attr])) {
        highlightRect(rect, 500);
        message.error($t('k_c3aaf766'));
        this.editPagelet.id = this.pagelet.id;
      } else this.refreshPagelets();
    },
    handleDescChange() {
      if (this.editPagelet.description === '') {
        this.editPagelet.description = undefined;
      }
      this.refreshPagelets();
    },
    refreshPagelets() {
      this.pagelets.forEach((item) => {
        if (item.id === this.pagelet.id) {
          Object.assign(item, this.editPagelet);
        }
      });
      Object.assign(this.pagelet, this.editPagelet);
      // 修改后重新设置激活的页面片id
      this.xyPageConfig.handleSelectPagelet(this.editPagelet.id);
    },
  },
});
</script>

<style lang="scss" scoped>
::v-deep .ant-form-item {
  margin-bottom: 0px;
  .ant-form-item-label {
    text-align: left;
  }
}
</style>
